import React, { useState, useEffect } from "react";
import { ContainerAuto } from "@/shared/ContainerAuto";
import { Menu, ContentLeft, Logo, SectionScroll } from "../../styles";
import ContentIcon from "@/shared/ContentIcon";
import LoginSubscription from "@/shared/Header/components/LoginSubscription";
import { handleClick } from "@/shared/Analitics/GoogleAnalytics4";
import MenuLateral from "../Menu/components/MenuLateral";
import Notifications from "@/shared/Notifications";

const HeadingDefault = ({
  isHome,
  isNews,
  suscriptionPrice,
  isPreview = false,
  menulateral,
  sectionData,
  subheaderEnable,
  showGoolgeOneTap,
  urlSubscription = "https://365.clarin.com/?utm_source=clarin&utm_medium=header&utm_campaign=gota365&utm_id=gota365&utm_term=homeclarin",
  nameIcon= "logoClarin",
  heightIcon,
  cssClass,
  logoUrlSection,
  titleHeader = "",
  bannerHorizantalOneEnable = true,
  logoVariant, // establece margen-left logo claríon 80 aniversario
  hideSectionScroll = false,
  isTitleHeader = false,
  urlIsRecipes = false
}) => {
  const [scroll, setScroll] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const TAGTitleHeader = isNews ? "p" : "h1";

  useEffect(() => {
    if(typeof window !== "undefined") {
      setIsMobile(window.innerWidth < 1024)
    }
  
  }, []);

  // useEffect(() => {
  //   window.addEventListener("scroll", () => {
  //     if (window.innerWidth > 1024) {
  //       setScroll(window.scrollY > 416);
  //     } else {
  //       setScroll(window.scrollY > 36);
  //     }
  //   });
  // }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    // umbral: 0 = cualquier desplazamiento; pon 1 o más si querés ignorar micro-scrolls
    const threshold = 1;
    let ticking = false;

    // init: si ya hay scroll al montar, aplico la clase inmediatamente
    setScroll(window.scrollY > threshold);

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(() => {
          const shouldBeSticky = window.scrollY > threshold;
          setScroll(shouldBeSticky);
          ticking = false;
        });
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  let logoUrl = "/";
  const logoNameIcon = scroll && isTitleHeader && !isMobile ? "logoClarin-shrink" : "logoClarin"


  return (
    <Menu
      className={`${!subheaderEnable && "sticky"} ${scroll ? "sticky stickyWithBanner" : "no-sticky"
        } ${bannerHorizantalOneEnable ? "bannerEnabled" : "bannerDisabled" 
      } ${cssClass} ${!subheaderEnable && bannerHorizantalOneEnable ? "bannerWithSubheaderDisabled" : ""}`} 
      isHome={isHome}
      id="headerId"
    >
      <ContainerAuto className="container-sticky">
      <ContainerAuto className="containerCenter">
        <ContentLeft className={`${logoNameIcon ? logoNameIcon : ""}`}>
          <MenuLateral
            menulateral={menulateral}
            suscriptionPrice={suscriptionPrice}
            isHome={isHome}
          />
          {isHome ? (
            <span style={{ marginLeft: '5px' }}>
              <Logo
                variant={logoVariant} // establece margen-left logo claríon 80 aniversario
                href={logoUrl}
                onClick={() =>
                  handleClick("ui_interaction", "header clarin", "inicio")
                }
                aria-label="clarin.com"
              >
                {<ContentIcon fill="#d80026" nameIcon={logoNameIcon}  />}
              </Logo>
            </span>
          ) : (
            <>
              <Logo
                variant={logoVariant} // establece margen-left logo claríon 80 aniversario
                className={`${logoNameIcon ? logoNameIcon : ""}`}
                href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/${logoUrlSection != undefined ? logoUrlSection : ""
                  }`}
                onClick={() =>
                  handleClick("ui_interaction", "header clarin", "inicio")
                }
                aria-label={`clarin.com/${logoUrlSection}`}
              >
                {<ContentIcon fill="#d80026" nameIcon={logoNameIcon} {...(heightIcon &&{ height: heightIcon })}  />}
                {isTitleHeader&& !isMobile && scroll && <TAGTitleHeader className="tagTitleDesktop">{titleHeader}</TAGTitleHeader>}
              </Logo>
              {(!subheaderEnable || scroll) && sectionData.name && !hideSectionScroll && (
                <SectionScroll
                className="SectionScroll"
                  href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/${sectionData.url != undefined ? sectionData.url : ""
                    }`}
                >
                  {sectionData.name}
                </SectionScroll>
              )}
            </>
          )}
        </ContentLeft>

        {!isPreview && (
          <>
            <Notifications />
            <LoginSubscription
            className="contentUser"
            suscriptionPrice={suscriptionPrice}
              urlSubscription={urlSubscription}
              isHome={isHome}
              showGoolgeOneTap={showGoolgeOneTap}
            />
          </>
        )}
      </ContainerAuto>
      </ContainerAuto>
    </Menu >
  );
};

export default HeadingDefault;
